// src/pages/Dashboard/Admin/DetailsAdherents/components/DashboardAdherentHeader.jsx

import React from "react";
import { FaIdCard } from "react-icons/fa";

export default function DashboardAdherentHeader() {
  return (
    <header className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

      <div className="p-4 sm:p-5 lg:p-6">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
          <div>
            <p className="text-[11px] uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
              Détails adhérents
            </p>

            <h1 className="mt-1 flex items-center gap-3 text-2xl font-bold text-slate-900 sm:text-[30px] dark:text-white">
              <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-indigo-50 text-indigo-700 dark:bg-indigo-500/10 dark:text-indigo-300">
                <FaIdCard />
              </span>
              Détails Adhérents
            </h1>

            <p className="mt-2 max-w-4xl text-sm leading-6 text-slate-600 dark:text-slate-300">
              Fiche complète d’un adhérent avec une lecture dashboard :
              identité, groupes, dossier, règlement, ceintures, compétitions,
              palmarès, achats et présences.
            </p>
          </div>
        </div>
      </div>
    </header>
  );
}